// Price Slider Modal for order_amount filtering
// TODO: Stimulus controller化する際は data-controller="price-slider" に移行

document.addEventListener('DOMContentLoaded', function() {
  var minSlider = document.getElementById('minSlider');
  var maxSlider = document.getElementById('maxSlider');

  // モーダルが存在しないページでは何もしない
  if (!minSlider || !maxSlider) return;

  var minInput = document.getElementById('minInput');
  var maxInput = document.getElementById('maxInput');
  var minDisplay = document.getElementById('minDisplay');
  var maxDisplay = document.getElementById('maxDisplay');
  var sliderRange = document.getElementById('sliderRange');
  var orderAmountGteqField = document.getElementById('order_amount_gteq_field');
  var orderAmountLteqField = document.getElementById('order_amount_lteq_field');

  var SLIDER_MAX = 100000000;
  var actualMinValue = 0;
  var actualMaxValue = null;

  function formatNumber(num) {
    return num.toLocaleString('ja-JP');
  }

  function formatPrice(num) {
    if (num === null) return '上限なし';
    if (num >= 100000000) {
      var oku = num / 100000000;
      return oku % 1 === 0 ? oku + '億円' : oku.toFixed(1) + '億円';
    } else if (num >= 10000) {
      var man = num / 10000;
      return formatNumber(man) + '万円';
    }
    return formatNumber(num) + '円';
  }

  function updateSliderRange() {
    var minVal = parseInt(minSlider.value);
    var maxVal = parseInt(maxSlider.value);
    var minPercent = (minVal / SLIDER_MAX) * 100;
    var maxPercent = (maxVal / SLIDER_MAX) * 100;
    sliderRange.style.left = minPercent + '%';
    sliderRange.style.width = (maxPercent - minPercent) + '%';
  }

  function updateDisplays() {
    var minVal = actualMinValue !== null && actualMinValue !== undefined ? actualMinValue : parseInt(minSlider.value);
    var sliderMaxVal = parseInt(maxSlider.value);
    var isNoLimit = sliderMaxVal >= SLIDER_MAX && actualMaxValue === null;

    minDisplay.textContent = formatPrice(minVal);

    if (isNoLimit) {
      maxDisplay.textContent = '上限なし';
      maxDisplay.classList.add('no-limit');
      maxInput.value = '';
      maxInput.placeholder = '上限なし';
    } else {
      var displayMax = actualMaxValue !== null ? actualMaxValue : sliderMaxVal;
      maxDisplay.textContent = formatPrice(displayMax);
      maxDisplay.classList.remove('no-limit');
      maxInput.value = formatNumber(displayMax / 1000);
    }

    minInput.value = formatNumber(minVal / 1000);
    updateSliderRange();
  }

  // Shortcut buttons
  function updateShortcutButtons() {
    document.querySelectorAll('.price-shortcut').forEach(function(btn) {
      var btnMin = parseInt(btn.dataset.min);
      var btnMaxRaw = btn.dataset.max;
      var btnMax = btnMaxRaw === '' ? null : parseInt(btnMaxRaw);

      var isActive = false;
      if (btnMax === null) {
        isActive = (actualMinValue === btnMin && actualMaxValue === null);
      } else {
        isActive = (actualMinValue === btnMin && actualMaxValue === btnMax);
      }
      btn.classList.toggle('active', isActive);
    });
  }

  function parseInput(value) {
    var cleaned = value.replace(/,/g, '');
    if (cleaned === '' || cleaned === '上限なし') return null;
    return parseInt(cleaned) || 0;
  }

  // Initialize slider from existing field values
  function initSliderFromFields() {
    var gteqVal = orderAmountGteqField.value;
    var lteqVal = orderAmountLteqField.value;

    var parsedMin = gteqVal ? parseInt(gteqVal.replace(/,/g, '')) : null;
    var parsedMax = lteqVal ? parseInt(lteqVal.replace(/,/g, '')) : null;

    if (parsedMin !== null && parsedMax !== null && parsedMin > parsedMax) {
      var tmp = parsedMin;
      parsedMin = parsedMax;
      parsedMax = tmp;
    }

    if (parsedMin !== null) {
      actualMinValue = parsedMin;
      minSlider.value = Math.min(parsedMin, SLIDER_MAX);
    }
    if (parsedMax !== null) {
      actualMaxValue = parsedMax;
      maxSlider.value = Math.min(parsedMax, SLIDER_MAX);
    }

    updateDisplays();

  }

  // Slider event listeners
  minSlider.addEventListener('input', function() {
    var minVal = parseInt(minSlider.value);
    var maxVal = parseInt(maxSlider.value);
    if (minVal > maxVal) {
      minSlider.value = maxVal;
    }
    actualMinValue = parseInt(minSlider.value);
    updateDisplays();
    updateShortcutButtons();
  });

  maxSlider.addEventListener('input', function() {
    var minVal = parseInt(minSlider.value);
    var maxVal = parseInt(maxSlider.value);
    if (maxVal < minVal) {
      maxSlider.value = minVal;
    }
    var clampedMax = parseInt(maxSlider.value);
    if (clampedMax >= SLIDER_MAX) {
      actualMaxValue = null;
    } else {
      actualMaxValue = clampedMax;
    }
    updateDisplays();
    updateShortcutButtons();
  });

  minInput.addEventListener('change', function() {
    var val = parseInput(this.value);
    if (val === null) val = 0;
    val = val * 1000;
    var maxVal = actualMaxValue !== null ? actualMaxValue : SLIDER_MAX;
    val = Math.max(0, Math.min(val, maxVal));
    actualMinValue = val;
    minSlider.value = Math.min(val, SLIDER_MAX);
    updateDisplays();
    updateShortcutButtons();
  });

  maxInput.addEventListener('change', function() {
    var val = parseInput(this.value);
    var minVal = parseInt(minSlider.value);

    if (val === null) {
      actualMaxValue = null;
      maxSlider.value = SLIDER_MAX;
    } else {
      val = val * 1000;
      val = Math.max(minVal, val);
      actualMaxValue = val;
      maxSlider.value = Math.min(val, SLIDER_MAX);
    }
    updateDisplays();
    updateShortcutButtons();
  });

  // Shortcut button click
  document.querySelectorAll('.price-shortcut').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var btnMin = parseInt(this.dataset.min);
      var btnMaxRaw = this.dataset.max;
      var btnMax = btnMaxRaw === '' ? null : parseInt(btnMaxRaw);

      actualMinValue = btnMin;
      actualMaxValue = btnMax;
      minSlider.value = Math.min(btnMin, SLIDER_MAX);
      maxSlider.value = btnMax !== null ? Math.min(btnMax, SLIDER_MAX) : SLIDER_MAX;
      updateDisplays();
      updateShortcutButtons();
    });
  });

  // Modal controls (window.$ for Semantic UI modal)
  document.getElementById('openPriceModal').addEventListener('click', function() {
    initSliderFromFields();
    window.$('#priceModal').modal('show');
  });

  document.getElementById('clearPrice').addEventListener('click', function() {
    minSlider.value = 0;
    maxSlider.value = SLIDER_MAX;
    actualMinValue = 0;
    actualMaxValue = null;
    updateDisplays();
    updateShortcutButtons();
    orderAmountGteqField.value = '';
    orderAmountLteqField.value = '';
    window.$('#priceModal').modal('hide');
  });

  document.getElementById('applyPrice').addEventListener('click', function() {
    var minVal = actualMinValue;
    var maxVal = actualMaxValue;

    orderAmountGteqField.value = minVal > 0 ? minVal : '';
    orderAmountLteqField.value = maxVal !== null ? maxVal : '';

    if (minVal > 0) {
      var changeEvent = new Event('change', { bubbles: true });
      orderAmountGteqField.dispatchEvent(changeEvent);
    }
    if (maxVal !== null) {
      var changeEvent = new Event('change', { bubbles: true });
      orderAmountLteqField.dispatchEvent(changeEvent);
    }

    window.$('#priceModal').modal('hide');
  });

  // Initialize
  initSliderFromFields();
  updateShortcutButtons();
});
